import request from '@/utils/request'

// 新增采购订单
export function doPurchaseOrder(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/add',
    method: 'post',
    data,
  })
}

// 采购订单状态统计
export function getTabCount(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/summary',
    method: 'post',
    data,
  })
}
// 采购订单列表查询
export function getPurchaseList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/list',
    method: 'post',
    data,
  })
}
// 采购订单退车结算信息详情
export function getSettlementDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/detail',
    method: 'post',
    data,
  })
}
// 获取采购订单详情
export function getPurchaseDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/detail',
    method: 'post',
    data,
  })
}


// 子订单列表
export function getSubOrderList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/list',
    method: 'post',
    data,
  })
}
// 子订单详情--订单信息
export function getSubOrderDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/detail',
    method: 'post',
    data,
  })
}

// 批量退车根据车辆id回显详情
export function getCarDetail(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/returnable/car/detail',
    method: 'post',
    data,
  })
}

// 采购子订单退车核算 --- 提交
export function confirmSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/submit',
    method: 'post',
    data,
  })
}
// 采购子订单退车核算 --- 保存
export function saveSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/save',
    method: 'post',
    data,
  })
}
// 采购子订单结算应收应退金额计算
export function calculateCarAmount(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/settlement/calculate',
    method: 'post',
    data,
  })
}

// 子订单新增车辆
export function purchaseSubAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/add',
    method: 'post',
    data,
  })
}

// 采购子订单统计
export function purchaseSubSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/summary',
    method: 'post',
    data,
  })
}

// 采购子订单统计
export function purchaseCarAddImport(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/car/import',
    method: 'post',
    data,
  })
}


// 支付计划-查看应收单详情
export function purchaseCloseOrder(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/close',
    method: 'post',
    data,
  })
}


// 订单可退车辆(子订单)列表，目前用于批量退车下拉接口 resourceKey=listReturnableCar
export function returnableCarList(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/returnable/car/list',
    method: 'post',
    data,
  })
}


// 采购订单批量退车导入(新增接口) resourceKey=importReturnCar
export function carImportant(data) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/returnable/car/import',
    method: 'post',
    data,
  })
}

// 新增租赁方案V2 @邓长亮
export function createPlanScheme(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/create',
    method: 'post',
    data,
  })
}

// 编辑租赁方案V2-企业 @邓长亮
export function editEnterPlanScheme(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/edit',
    method: 'post',
    data,
    signParams: ['id', 'modelId', 'templateId', 'rentCategory', 'rentFeeList[0].amount'],
  })
}

// 编辑租赁方案V2 @邓长亮
export function editPlanScheme(data) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/signCheck/edit',
    method: 'post',
    data,
    signParams: ['id', 'modelId', 'templateId', 'rentCategory', 'rentFeeList[0].amount'],
  })
}


/**
 * @apiName 保险比价列表
 */
export function getInsureOrderList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/routines/insComp/orderList',
    method: 'POST',
    data,
  })
}

// 发起保险询价
export function submitInsuranceInquiry(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/routines/insComp/sendInsuranceInquiry',
    method: 'POST',
    data,
  })
}

// 查询保险订单详情
export function getInsureOrderDetail(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/routines/insComp/underwritingOrderList',
    method: 'POST',
    data,
  })
}

// 关闭订单
export function closeInsureOrder(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/routines/insComp/closeOrder',
    method: 'POST',
    data,
  })
}

// 保险比价订单基本信息-支付及保单信息tab页
export function getOrderBaseInfo(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/routines/insComp/orderDetail',
    method: 'POST',
    data,
  })
}

// 提交支付凭证
export function submitCommitPaymentVoucher(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/routines/insComp/commitPaymentVoucher',
    method: 'POST',
    data,
  })
}

// 修改比价方案
export function modifyInsuranceScheme(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/routines/insComp/editProgramme',
    method: 'POST',
    data,
  })
}

// 提交核保
export function submitUnderwriting(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/routines/insComp/commitUnderwriting',
    method: 'POST',
    data,
  })
}

// 获取列表筛选项
export function getOrderStatusCnt(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/routines/insComp/orderStatusCnt',
    method: 'POST',
    data,
  })
}

// 导入投保车辆
export function importInsureCar(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/routines/insComp/importCarList',
    method: 'POST',
    data,
  })
}

/**
 * 创建个人租赁方案
 * @param {number} data.brandId 品牌id
 * @param {number} data.seriesId 车系id
 * @param {number} data.modelId 车型id
 * @param {array<string>} data.cityCodes 所属城市编码集合
 * @param {string} data.name 方案名称
 * @param {number} data.orderType 方案类型 1-个人租赁方案 2-企业租赁方案
 * @param {number} data.rentCategory 租赁类型 1-纯租 2-以租代购 4-司机合作
 * @param {number} data.payMode 收款方式 4-月付(满月) 5-月付(自然月) 3-周付 10-日付；司机合作时：5-月结 12-周结 10 日结
 * @param {number} data.presentDays 赠送天数
 * @param {number} data.rentPeriod 租期
 * @param {number} data.rentPeriodType 租期类型 1-天 3-月
 * @param {number} data.templateId 合同模板id
 * @param {array<object>} data.rentFeeList 租赁账单列表
 * @param {object} data.payPlanFee 司机合作规则
 */
export function createPersonalPlan(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/signCheck/personalCreate',
    method: 'POST',
    data,
    signParams: ['name', 'modelId', 'templateId', 'rentCategory', 'rentFeeList[0].amount'],
  })
}

/**
 * 编辑个人租赁方案
 * @param {number} data.brandId 品牌id
 * @param {number} data.seriesId 车系id
 * @param {number} data.modelId 车型id
 * @param {array<string>} data.cityCodes 所属城市编码集合
 * @param {string} data.name 方案名称
 * @param {number} data.orderType 方案类型 1-个人租赁方案 2-企业租赁方案
 * @param {number} data.rentCategory 租赁类型 1-纯租 2-以租代购 4-司机合作
 * @param {number} data.payMode 收款方式 4-月付(满月) 5-月付(自然月) 3-周付 10-日付；司机合作时：5-月结 12-周结 10 日结
 * @param {number} data.presentDays 赠送天数
 * @param {number} data.rentPeriod 租期
 * @param {number} data.rentPeriodType 租期类型 1-天 3-月
 * @param {number} data.templateId 合同模板id
 * @param {array<object>} data.rentFeeList 租赁账单列表
 * @param {object} data.payPlanFee 司机合作规则
 * @returns
 */
export function editPersonalPlan(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/signCheck/personalEdit',
    method: 'POST',
    data,
    signParams: ['id', 'modelId', 'templateId', 'rentCategory', 'rentFeeList[0].amount'],
  })
}
